import type {ZodSchema} from 'zod';

// Generate a records of all fields in a Zod schema (not working for nested schemas)
export function getZodFlatSchemaFields(schema: ZodSchema): Record<string, true> {
  const fields: Record<string, true> = {};
  const proxy = new Proxy(fields, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    get(_, key) {
      if (key === 'then' || typeof key !== 'string') {
        return;
      }
      fields[key] = true;
    },
  });
  schema.safeParse(proxy);
  return fields;
}
